/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_COURSE (state, course) {
    state.courses.unshift(course)
  },
  SET_COURSES (state, courses) {
    state.courses = courses
  },
  // SET_LABELS(state, labels) {
  //   state.eventLabels = labels
  // },
  UPDATE_COURSE (state, course) {
    const courseIndex = state.courses.findIndex((p) => p._id === course._id)
    Object.assign(state.courses[courseIndex], course)
  },
  REMOVE_COURSE (state, courseId) {
    const courseIndex = state.courses.findIndex((p) => p._id === courseId)
    state.courses.splice(courseIndex, 1)
  },
  //LESSONS
  ADD_LESSON (state, lesson) {
    state.lessons.unshift(lesson)
  },
  SET_LESSONS (state, lessons) {
    
    state.lessons = [...lessons]
  },
  // SET_LABELS(state, labels) {
  //   state.eventLabels = labels
  // },
  UPDATE_LESSON (state, lesson) {
    const lessonIndex = state.lessons.findIndex((p) => p.id === lesson.id)
    // console.log('lesson from db line 50', lesson)
    // console.log('lesson from state line 51', state.lessons[lessonIndex])
    Object.assign(state.lessons[lessonIndex], lesson)
  },
  REMOVE_LESSON (state, lessonId) {
    const lessonIndex = state.lessons.findIndex((p) => p.id === lessonId)
    state.lessons.splice(lessonIndex, 1)
  },
  //MODULES
  SET_MODULES (state, modules) {
    state.modules = modules
  }
}
